import {PureComponent} from "react"
import React from "react"

export function withDialogState() {
  return (WrappedComponent) => {
    class WithDialogState extends PureComponent {

      constructor(props) {
        super(props)

        this.state = {
          open: false
        }
      }

      onOpenDialog() {
        this.setState({open: true})
      }

      onCloseDialog() {
        this.setState({open: false})
      }

      render() {
        return <WrappedComponent {...this.props}
                                 isOpen={this.state.open}
                                 onOpenDialog={this.onOpenDialog.bind(this)}
                                 onCloseDialog={this.onCloseDialog.bind(this)}/>
      }
    }

    return WithDialogState
  }
}
